import mapperIcon from '../../../../core/data-layer/utils/mappers/mapper-icon'
import type { MapperOptions } from '#layers/core/types'

/**
 * Page policies and disclaimer mapper
 * normalizes data to be used in pages
 */
export default (data: any, options: MapperOptions) => {
  if (!data) {
    return null
  }

  return {
    items:
      data.itemsCollection?.items.filter(Boolean).map((item: any) => ({
        title: item.navigationTitle || '',
        link: {
          url: options.getInternalUrl(item.sys.id),
          title: options.labels?.readMore || '',
          ariaLabel: item.navigationTitle || ''
        },
        icon: mapperIcon(item?.icon)
      })) || []
  }
}
